import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { from } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var INDRAIbeAdminConfigService = /** @class */ (function () {
    function INDRAIbeAdminConfigService(http) {
        this.http = http;
        this.ibeadmin_debug = false; // to show/hide ibeadmin texts with asterisc mark and help development
        this.configurationsObj = {};
        this.configurationsByKey = new Map();
        this.loadedModules = new Set();
    }
    INDRAIbeAdminConfigService.prototype.loadConfigurations = function (scopeId, moduleIds) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) { return _this._loadConfigurations(scopeId, moduleIds, resolve, reject); });
        return from(promise);
    };
    INDRAIbeAdminConfigService.prototype._loadConfigurations = function (scopeId, moduleIds, resolve, reject) {
        var _this = this;
        var modulesToLoad = new Array();
        moduleIds.forEach(function (moduleId) {
            if (!_this.loadedModules.has(moduleId))
                modulesToLoad.push(moduleId);
        });
        if (modulesToLoad.length > 0) {
            this.http.post(environment.api_url + "ibe/rest/scopes/" + scopeId + "/modules/configurations", { modules: modulesToLoad }).subscribe(function (data) {
                data.forEach(function (moduleTranslations) {
                    if (_this.configurationsObj)
                        Object.assign(_this.configurationsObj, moduleTranslations);
                    else
                        _this.configurationsObj = moduleTranslations;
                });
                modulesToLoad.forEach(function (moduleId) {
                    if (!_this.loadedModules.has(moduleId))
                        _this.loadedModules.add(moduleId);
                });
                Array.from(_this.configurationsByKey.keys()).forEach(function (key) { return _this.configurationsByKey.get(key).next(_this.getConfigurationValue(key)); });
                resolve(data);
            }, function (error) { return reject(error); });
        }
    };
    INDRAIbeAdminConfigService.prototype.getConfigurationValue = function (key) {
        var _this = this;
        if (this.ibeadmin_debug) {
            console.debug('[IBE-Admin] Getting configuration key ' + key);
        }
        if (this.configurationsObj) {
            var keyValues = key.split('.');
            var result_1 = null;
            keyValues.forEach(function (value) {
                if (result_1 === null)
                    result_1 = _this.configurationsObj[value];
                else
                    result_1 = result_1[value] ? result_1[value] : '';
            });
            if (result_1) {
                if (this.ibeadmin_debug)
                    return "*" + result_1 + "*";
                else
                    return result_1.toString();
            }
            else {
                console.warn('[IBE-Admin] Configuration key not found: \'' + key + '\'');
                return key;
            }
        }
        else
            return key;
    };
    INDRAIbeAdminConfigService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAIbeAdminConfigService_Factory() { return new INDRAIbeAdminConfigService(i0.inject(i1.HttpClient)); }, token: INDRAIbeAdminConfigService, providedIn: "root" });
    return INDRAIbeAdminConfigService;
}());
export { INDRAIbeAdminConfigService };
